import {
  Button,
  ButtonGroup,
  Dialog,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  MenuList,
  Popper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useMaterialUIController } from "context";
import { useEffect, useState } from "react";
import getText from "Translator";
import { setAction } from "context";
import { setLoading } from "context";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
let clearError = false;
let tempAnswers = [];
export default function FlatBComponent(props) {
  const [error, setError] = useState(false);
  const [selectedAnswers, setSelectedAnswers] = useState([]);
  const [topAnswer, setTopAnswer] = useState(null);
  const [currentAnswer, setCurrentAnswer] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [subAnswers, setSubAnswers] = useState(null);
  const [multiSub, setMultiSub] = useState(false);
  const [displayAnswers, setDisplayAnswers] = useState([]);
  const [reload, setReload] = useState(new Date());

  const {
    question,
    disabled,
    editQuestionHandle,
    helpPage,
    headline,
    setFocuse,
  } = props;

  const [answers, setAnswers] = useState(question.answers);
  const [controller, dispatch] = useMaterialUIController();
  const handleClose = (selectedAnswersParams) => {
    handleClick(
      "",
      selectedAnswersParams ? selectedAnswersParams : selectedAnswers
    );
    setAnchorEl(null);
  };
  useEffect(() => {
    if (question.code == 3330) {
      console.log(question);
    }
    let newAnswers = [];
    question.answers.map((item) => {
      if (!item.topAnswer || item.topAnswer === null) {
        item.topAnswer = null;
        newAnswers.push(item);
      }
    });
    console.log("questionquestion", newAnswers);
    // let newAnswers = question.answers.filter((a) => a.topAnswer === null);

    setSelectedAnswers(question.useranswer);
    let subAns = [];
    newAnswers.map((topAns) => {
      subAns = [];
      console.log(
        "questionquestion, question",
        typeof question.useranswer,
        question.useranswer
      );
      if (!question.useranswer) {
        question.useranswer = [];
      }
      if (typeof question.useranswer == "string") {
        question.useranswer = [question.useranswer];
      }
      question.useranswer?.map((ans) => {
        let ansx = question.answers.filter((a) => a.id + "" === ans + "");
        if (ansx.length > 0) {
          ansx = ansx[0];

          if (
            ansx.topAnswer &&
            (subAns.includes(ansx.topAnswer) ||
              ansx.topAnswer + "" == topAns.id + "") &&
            !subAns.includes(ansx.id)
          ) {
            // console.log(ans);
            subAns.push(ans);
          }
        }
      });

      topAns.subAns = [];
      subAns.map((item) => {
        topAns.subAns.push(
          question.answers.filter((a) => a.id + "" === item + "")[0]
        );
      });
    });
    setDisplayAnswers(newAnswers);
  }, []);

  const handleClick = async (ans, selectedAnswersParam, removedId) => {
    setTimeout(async () => {
      // setFocuse();
      clearError = true;
      let ansId = ans ? ans.id : "";

      await editQuestionHandle(
        question,
        selectedAnswersParam,
        false,
        removedId,
        ans?.toBack
      );

      if (ans) {
        if (ans.help) {
          helpPage(ans.help);
        } else {
          if (ans.isNext && headline !== "scores") {
            setAction(dispatch, "nextpage" + new Date());
          }
          if (ans.isBack && headline !== "scores") {
            setLoading(dispatch, true);
            setAction(dispatch, "backpage" + new Date());
          }
        }
      }
    }, 100);
  };
  const removeAnswerAnsSubs = (item) => {
    let newTemp = [];

    // console.log("itemitemitemitemitem", item, selectedAnswers.length);
    let temp = selectedAnswers.filter((a) => a + "" !== item.id + "");

    let completed = false;
    let counter = 0;
    while (!completed) {
      if (
        counter >
        selectedAnswers.length * selectedAnswers.length * selectedAnswers.length
      ) {
        completed = true;
      }
      console.log("counter", temp);
      counter += 1;
      let allowLoop = true;
      temp.map((tempItem, index) => {
        if (allowLoop) {
          let ansx = question.answers.filter(
            (a) => a.id + "" === tempItem + ""
          );

          if (ansx[0]?.topAnswer) {
            let tt = temp.filter((a) => a + "" == ansx[0]?.topAnswer);

            if (tt.length == 0) {
              allowLoop = false;
              temp = temp.filter((a) => a !== tempItem);
              //completed = true;
            } else {
              // allowLoop = false;
              // temp = temp.filter((a) => a !== tempItem);
            }
          }
        }
      });
    }

    return temp;
    // temp.map((tempItem) => {
    //   let ansx = question.answers.filter((a) => a.id + "" === tempItem + "");
    //   console.log('ansxansx',ansx )
    //   ansx = ansx[0];
    //   if (!ansx.topAnswer) {
    //     newTemp.push(tempItem);
    //   } else {
    //     let added = false;
    //     let counter = 0;
    //     while (!added) {
    //       if (ansx.topAnswer + "" == tempItem + "") {
    //         newTemp.push(tempItem);
    //         added = true;
    //       } else {
    //         if (counter == selectedAnswers.length) {
    //           added = true;
    //         }
    //         counter += 1;
    //         let ansxx = question.answers.filter(
    //           (a) => a.id + "" === ansx.topAnswer + ""
    //         );
    //         if (!ansxx[0]?.topAnswer) {
    //           newTemp.push(tempItem);
    //           added = true;
    //         }

    //         if (!ansxx[0]?.topAnswer + "" == item.id + "") {
    //           added = true;
    //         }
    //       }
    //     }
    //   }
    // });
    // newTemp = newTemp.filter((a) => a + "" !== item.id + "");

    // console.log("1", newTemp);
    // let topx = question.answers.filter(
    //   (a) => a.id + "" === item.topAnswer + ""
    // );
    // topx = topx[0];
    // if (!topx.topAnswer) {
    //   let ansxx = question.answers.filter(
    //     (a) => a.topAnswer + "" === topx.id + ""
    //   );

    //   let hasSub = false;
    //   ansxx.map((tem) => {
    //     console.log(tem.id, newTemp.includes(tem.id));
    //     if (newTemp.includes(tem.id)) hasSub = true;
    //   });
    //   console.log("hasSub", hasSub);
    //   // console.log("hasSub", hasSub);
    //   if (!hasSub) {
    //     newTemp = newTemp.filter((a) => a + "" !== topx.id + "");
    //   }
    // }
    // console.log("2", newTemp);
    // return newTemp;
  };
  return (
    <Grid
      item
      xs={
        question.fixTop || question.fixBottom
          ? 12
          : question.size
          ? question.size
          : 12
      }
      sm={
        question.fixTop || question.fixBottom
          ? 12
          : question.size
          ? question.size
          : 12
      }
      md={
        question.fixTop || question.fixBottom
          ? 12
          : question.size
          ? question.size
          : 12
      }
      style={{
        position: question.fixTop || question.fixBottom ? "fixed" : "unset",
        left: question.fixTop || question.fixBottom ? 0 : "unset",
        right: question.fixTop || question.fixBottom ? 0 : "unset",
        top: question.fixTop ? 0 : "unset",
        bottom: question.fixBottom ? 0 : "unset",
        paddingBottom: question.fixTop || question.fixBottom ? 10 : "unset",
        backgroundColor:
          question.fixTop || question.fixBottom ? "#FFF" : "unset",
        zIndex: question.fixTop || question.fixBottom ? 999 : "unset",
        paddingTop: question.fixTop ? 55 : question.fixBottom ? 10 : "unset",
        paddingBottom: question.fixBottom ? 55 : question.fixTop ? 10 : "unset",
        paddingRight: question.fixTop || question.fixBottom ? 15 : 3,
        paddingLeft: question.fixTop || question.fixBottom ? 15 : 3,

        marginTop:
          question.titleType === 5 ? -25 : question.displayTitle ? 5 : 8,
        marginBottom: question.helpPage ? -15 : 0,
        display: question.visible ? "" : "none",
        // paddingInlineEnd: question.size && question.size !== 12 ? 3 : "unset",
      }}
    >
      {question.titleType === 2 && question.displayTitle && (
        <b
          style={{
            cursor: "pointer",
            position: "relative",
            bottom: -15,
            backgroundColor: "#039dfc",
            zIndex: 2,
            marginLeft: 10,
            marginRight: 10,
            paddingLeft: 5,
            paddingRight: 5,
            overflow: "hidden",
          }}
          title={getText("removevalue", controller.lang)}
          onClick={() => {
            handleClick();
          }}
        >
          <CloseIcon />
          {question.text}
        </b>
      )}
      {question.titleType === 1 && question.displayTitle && (
        <b
          onClick={() => {
            handleClick();
          }}
          title={getText("removevalue", controller.lang)}
          style={{
            cursor: "pointer",
          }}
        >
          {" "}
          <CloseIcon />
          {question.text}
        </b>
      )}

      {answers && displayAnswers && (
        <div
          className="miniflex"
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "space-between",
            border: "1px solid #039dfc",
            borderRight: "none",
            borderBottom: "none",
            borderRadius: 6,
          }}
          variant="outlined"
        >
          {displayAnswers.map((ans, index) => (
            <div
              style={{
                paddingInline:
                  question.fontSize && question.fontSize == "small" ? 1 : 5,
                borderRight:
                  (question.answers?.filter(
                    (a) => a.topAnswer + "" == ans.id + ""
                  ).length == 0 &&
                    question.useranswer.includes(ans.id + "")) ||
                  (question.answers.filter(
                    (a) => a.topAnswer + "" == ans.id + ""
                  ).length > 0 &&
                    question.useranswer.some((ai) =>
                      question.answers
                        .filter((a) => a.topAnswer + "" == ans.id + "")
                        .map((s) => s.id)
                        .includes(ai)
                    ))
                    ? "1px solid #FFF"
                    : "1px solid #039dfc",
                borderBottom:
                  (question.answers.filter(
                    (a) => a.topAnswer + "" == ans.id + ""
                  ).length == 0 &&
                    question.useranswer.includes(ans.id + "")) ||
                  (question.answers.filter(
                    (a) => a.topAnswer + "" == ans.id + ""
                  ).length > 0 &&
                    question.useranswer.some((ai) =>
                      question.answers
                        .filter((a) => a.topAnswer + "" == ans.id + "")
                        .map((s) => s.id)
                        .includes(ai)
                    ))
                    ? "1px solid #FFF"
                    : "1px solid #039dfc",

                flexGrow: 9999,
                borderBottomRightRadius:
                  question.answers.length - 1 == index ? 6 : 0,
                backgroundColor:
                  (question.answers.filter(
                    (a) => a.topAnswer + "" == ans.id + ""
                  ).length == 0 &&
                    question.useranswer.includes(ans.id + "")) ||
                  (question.answers.filter(
                    (a) => a.topAnswer + "" == ans.id + ""
                  ).length > 0 &&
                    question.useranswer.some((ai) =>
                      question.answers
                        .filter((a) => a.topAnswer + "" == ans.id + "")
                        .map((s) => s.id)
                        .includes(ai)
                    ))
                    ? "#039dfc"
                    : "inherit",
              }}
              key={ans.id}
            >
              <div
                onClick={(event) => {
                  //itemSelecHandler(event, ans, index)
                  setCurrentAnswer(ans.id);
                  let subAnswer = [];
                  let temp = [];
                  if (question.multiMode) {
                    temp = selectedAnswers;
                  } else {
                    if (selectedAnswers.includes(ans.id)) {
                      temp = selectedAnswers;
                    }
                  }
                  if (!temp.includes(ans.id)) {
                    temp.push(ans.id);
                  }
                  setSelectedAnswers(temp);

                  if (ans.topAnswer) {
                    let top = ans;
                    top = question.answers.filter(
                      (a) => a.id == top.topAnswer
                    )[0];
                    top.toBack = false;
                    subAnswer.push(top);
                  }
                  let subA = question.answers.filter(
                    (a) => a.topAnswer + "" === ans.id + ""
                  );

                  subAnswer = [...subA, ...subAnswer];
                  if (subAnswer.length > 0) {
                    setAnchorEl(event.currentTarget);
                    setMultiSub(ans.multiSub);
                    setSubAnswers(subAnswer);
                  } else {
                    handleClick(ans, temp);
                  }
                  return;
                }}
                style={{
                  width: "100%",
                  cursor: "pointer",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  flexDirection: "row",
                  display: "flex",
                  minWidth:
                    question.fontSize && question.fontSize == "small" ? 20 : 80,
                }}
              >
                <div
                  style={{
                    fontSize:
                      question.fontSize && question.fontSize == "small"
                        ? 12
                        : 14,
                    paddingBlock:
                      question.fontSize && question.fontSize == "small"
                        ? 11
                        : 8,
                    paddingInline:
                      question.fontSize && question.fontSize == "small" ? 1 : 8,

                    color:
                      (question.answers.filter(
                        (a) => a.topAnswer + "" == ans.id + ""
                      ).length == 0 &&
                        question.useranswer.includes(ans.id + "")) ||
                      (question.answers.filter(
                        (a) => a.topAnswer + "" == ans.id + ""
                      ).length > 0 &&
                        question.useranswer.some((ai) =>
                          question.answers
                            .filter((a) => a.topAnswer + "" == ans.id + "")
                            .map((s) => s.id)
                            .includes(ai)
                        ))
                        ? "#FFF"
                        : "#039dfc",
                  }}
                >
                  {(question.mainAnswerInMultiMode == true ||
                    ans.subAns.length == 0) &&
                    ans.answer}
                  {ans.subAns.map((tem, index) =>
                    question.mainAnswerInMultiMode || index > 0
                      ? question.multiModeVirgul
                        ? ", " + tem.answer
                        : "  " + tem.answer
                      : tem.answer
                  )}
                </div>

                {ans.help && (
                  <MoreVertIcon
                    style={{
                      position: "absolute",
                      color:
                        ans.id + "" === question.useranswer + ""
                          ? "#FFF"
                          : "#039dfc",
                      width: 15,
                      height: 15,
                      right: 0,
                      top: 1,
                    }}
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      )}
      {question.helpPage && (
        <Button
          style={{
            marginTop: -10,
          }}
          onClick={() => {
            helpPage(question.helpPage);
          }}
          className="helplink"
          fullWidth={true}
        >
          <div
            style={{
              width: "100%",
              fontSize: 11,
              textAlign: controller.lang == "fa" ? "left" : "right",
            }}
          >
            {question.helpText === ""
              ? getText("helptext", controller.lang)
              : question.helpText}
          </div>
        </Button>
      )}
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        closeAfterTransition={true}
        onClose={() => handleClose()}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        placement="bottom-start"
        style={{
          // padding:5,
          // borderRadius:8,
          // backgroundColor:'white',
          maxWidth: "90%",
        }}
      >
        <MenuList>
          {subAnswers &&
            subAnswers.map((item, index) => (
              <MenuItem
                style={{
                  paddingInline: 5,
                  backgroundColor: selectedAnswers.includes(item.id)
                    ? "#039dfc"
                    : "TRANSPARENT",
                  color: selectedAnswers.includes(item.id) ? "#FFF" : "#000",
                  marginBottom: 3,
                }}
              >
                {item.toBack && index === subAnswers.length - 1 && (
                  <ArrowBackIcon />
                )}
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{ width: "100%" }}
                    onClick={(event) => {
                      let temp = selectedAnswers;
                      if (!multiSub && !temp.includes(item.id)) {
                        let subsInGroup = question.answers.filter(
                          (a) => a.topAnswer == item.topAnswer
                        );

                        subsInGroup.map((item) => {
                          if (temp.includes(item.id)) {
                            temp = removeAnswerAnsSubs(item);
                          }
                        });
                        subsInGroup.map((item) => {
                          temp = temp.filter((a) => a + "" !== item.id + "");
                        });
                      }

                      if (!temp.includes(item.id)) {
                        temp.push(item.id);
                      }
                      console.log(temp);
                      setSelectedAnswers(temp);

                      let subAnswer = question.answers.filter(
                        (a) => a.topAnswer + "" === item.id + ""
                      );

                      // subAnswer = [...subA, ...subAnswer];
                      if (item.topAnswer) {
                        let top = question.answers.filter(
                          (a) => a.id == item.topAnswer
                        )[0];
                        top.toBack = true;
                        subAnswer.push(top);
                      }
                      if (subAnswer.length > 1) {
                        setMultiSub(item.multiSub);
                        setSubAnswers(subAnswer);
                      } else {
                        setReload(new Date());
                        if (!multiSub) {
                          handleClose(temp);
                        }
                        //handleClick(item, temp);
                      }
                    }}
                  >
                    {item.answer}
                  </div>
                  <div
                    style={{
                      paddingLeft: 5,
                      paddingRight: 5,
                      paddingTop: 2,
                    }}
                    onClick={(event) => {
                      let temp = removeAnswerAnsSubs(item);
                      setSelectedAnswers(temp);
                      console.log("multiSubmultiSub", multiSub);
                      if (!multiSub) {
                        //tak entekhabi
                        handleClose(temp);
                      }
                    }}
                  >
                    {selectedAnswers.includes(item.id) &&
                      !(item.toBack && index === subAnswers.length - 1) && (
                        <CloseIcon />
                      )}
                  </div>
                </div>
              </MenuItem>
            ))}
          {multiSub && (
            <MenuItem
              style={{}}
              onClick={(event) => {
                handleClose();
              }}
            >
              ثبت
            </MenuItem>
          )}
        </MenuList>
      </Menu>
    </Grid>
  );
}
